var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"listbox",style:(_vm.getStyle())},_vm._l((_vm.list),function(item,index){return _c('listbox-item',{key:index,attrs:{"item":item,"list-map":_vm.listMap,"action":_vm.action},on:{"item-action":function($event){return _vm.actionEvent(item, $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }